import { commonEnums } from '@codametrix/ui-common';
const { UserPreferenceKey } = commonEnums;
const getDefaultServiceLine = (preferences)=>{
    const res = preferences?.find((pref)=>pref.keyname === UserPreferenceKey.DEFAULT_USER_SERVICE_LINE)?.firstValue;
    if (res?.length) {
        return parseInt(res);
    }
};
const getDefaultOrg = (preferences)=>{
    const res = preferences?.find((pref)=>pref.keyname === UserPreferenceKey.DEFAULT_USER_CONTEXT)?.firstValue;
    if (res?.length) {
        return parseInt(res);
    }
};
const getHomepagePreference = (preferences)=>{
    const preference = preferences?.find((pref)=>pref.keyname === UserPreferenceKey.DEFAULT_HOMEPAGE);
    return preference;
};
const getContextHomepage = (tenantId = 'DOES_NOT_EXIST', preference)=>{
    const value = preference?.values.find((value)=>{
        return value.tenantId && value.tenantId === tenantId;
    });
    if (value && value.tenantId) {
        return {
            path: value.value,
            tenantId: value.tenantId
        };
    }
};
const getDemographicsPanelLocation = (preferences)=>{
    const res = preferences?.find((pref)=>pref.keyname === UserPreferenceKey.DEMOGRAPHICS_PANEL_LOCATION)?.firstValue;
    if (res?.length) {
        return res;
    }
};
const getDemographicsPanelVisibility = (preferences)=>{
    const res = preferences?.find((pref)=>pref.keyname === UserPreferenceKey.DEMOGRAPHICS_PANEL_VISIBILITY)?.firstValue;
    if (res?.length) {
        return res;
    }
};
export { getDefaultServiceLine, getDefaultOrg, getHomepagePreference, getContextHomepage, getDemographicsPanelLocation, getDemographicsPanelVisibility };
